
const $ = require('jquery');
require('rgs-bootstrap');

const forms = require('page-common-forms');


$(() => {
	$('[data-apply="page-common-inline-form"]').each(function () {
		const $this = $(this);

		const form = $this.attr('data-form');
		const productName = $this.attr('data-product');

		forms[form].inline(this, { productName });
	});
});

